import * as React from "react"
import { Icon } from "./Icon"
import { trackActivity } from "../activity"

const steps: { title: string; description: string; icon: React.ComponentProps<typeof Icon>["name"]; highlight?: boolean }[] = [
    { title: "Instant booking", description: "Securely book and pay for your hire equipment online.", icon: "zap" },
    { title: "Confirm delivery time", description: "We'll be in touch to confirm a delivery slot that works for you.", icon: "message" },
    { title: "No-hassle delivery", description: "We'll deliver the equipment to where you need it.", icon: "truck" },
    { title: "Enjoy the hire", description: "Put your equipment to work. We're available 7 days a week if you need help.", icon: "check-circle", highlight: true },
    { title: "Extend flexibly", description: "Before the end of your hire, we'll confirm if you need an extension.", icon: "calendar" },
    { title: "Home collection", description: "We'll agree a convenient collection time at the end of your hire to collect the equipment from your home.", icon: "refresh" },
]

export function HireProcess() {
    const dialogRef = React.useRef<HTMLDialogElement>(null)
    const titleId = React.useId()
    const [open, setOpen] = React.useState(false)

    React.useEffect(() => {
        if (!open) return
        const previousOverflow = document.body.style.overflow
        document.body.style.overflow = "hidden"
        return () => { document.body.style.overflow = previousOverflow }
    }, [open])

    return <>
        <button type="button" className="ah-panel ah-process-trigger" aria-haspopup="dialog" aria-expanded={open} onClick={() => {
            if (!dialogRef.current || dialogRef.current.open) return
            dialogRef.current.showModal()
            setOpen(true)
            trackActivity("hire_steps_viewed")
        }}>
            <Icon name="list-steps" /><span className="ah-section-title">How hiring works</span><Icon name="arrow" />
        </button>
        <dialog ref={dialogRef} className="ah-process-dialog" aria-labelledby={titleId} onClose={() => setOpen(false)}>
            <header>
                <div className="ah-process-brand"><span className="brand-mark ah-process-logo" aria-hidden="true" /><h2 id={titleId}>The Arctic Hire Process</h2></div>
                <button type="button" className="ah-process-close" aria-label="Close Arctic Hire process" autoFocus onClick={() => dialogRef.current?.close()}><span>Close</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M6 18 18 6" /></svg></button>
            </header>
            <div className="ah-process-content">
                <ol className="ah-process-steps" role="list">
                    {steps.map(step => <li key={step.title} className={step.highlight ? "ah-process-highlight" : undefined}>
                        <div><h3><Icon name={step.icon} /><span>{step.title}</span></h3><p>{step.description}</p></div>
                    </li>)}
                </ol>
            </div>
        </dialog>
    </>
}
